"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Orbitals = void 0;
var orbitals_1 = require("./orbitals");
Object.defineProperty(exports, "Orbitals", { enumerable: true, get: function () { return orbitals_1.Orbitals; } });
//# sourceMappingURL=index.js.map